import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../slices/authSlice';
import { useAuth } from '../../hook/useAuth';
import MenuItem from './MenuItem';
// Icons
import {
  Bell,
  FileUp,
  History,
  Menu,
  ShoppingCart,
  TriangleAlert,
  UserRoundPen,
} from 'lucide-react';
import { ClipboardList } from 'lucide-react';
import { Network } from 'lucide-react';
import { TextSearch } from 'lucide-react';
// Components
import React, { useCallback, useEffect } from 'react';
import { List, Card, ListItem, Typography, ListItemPrefix } from '@material-tailwind/react';
import { ArrowLeftStartOnRectangleIcon } from '@heroicons/react/24/outline';
import MeuCadastro from './MeuCadastro';
import ThemeMode from '../ThemeMode/ThemeMode';
import Hr from '../Hr';
import { changeNavBar, navBarmobileOffStart } from '../../slices/menubarSlice';
import { useMediaQuery, useTheme } from '@mui/system';
import MenuPcm from './MenuPcm';

const NavBar = () => {
  const { role } = useAuth();
  const navigate = useNavigate();
  const { statusBar } = useSelector((state) => state.navBar);
  const theme = useTheme();
  const smDow = useMediaQuery(theme.breakpoints.down('sm'));
  const { isSuper } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const handleLogout = () => {
    navigate('/');
    dispatch(logout());
  };

  useEffect(() => {
    if (smDow) {
      dispatch(navBarmobileOffStart());
    }
  }, [smDow]);

  const handleMenu = useCallback(() => {
    if (smDow) {
      dispatch(changeNavBar());
    }
  }, []);

  const handleChoseMenu = () => {
    dispatch(changeNavBar());
  };

  const LIST_ITEM_STYLES =
    'select-none text-white dark:text-white hover:bg-blue-900 focus:bg-text-blue-900  dark:focus:bg-blue-900 active:font-bold hover:text-blue-900 focus:font-bold active:text-blue-900 data-[selected=true]:bg-blue-900 ';

  return (
    <>
      <section
        className={`absolute z-50 left-0 top-0 m-0 p-0  md:relative place-items-center w-[18rem] shadow-md shadow-black dark:bg-none lg:grid  dark:bg-darkColorBg ${
          !statusBar && '!hidden'
        } `}
      >
        <div className="h-full flex flex-col !justify-between w-full overflow-auto global-scrollbar bg-lightMenu dark:bg-none dark:bg-darkColorBg">
          <Card
            className={`w-full max-w-[20rem] mx-auto shadow-md rounded-none  flex bg-transparent dark:bg-colorBg`}
          >
            <div className="flex items-center mx-2 gap-4 p-1 ">
              <Menu
                color="white"
                onClick={handleChoseMenu}
                className="cursor-pointer mt-1 w-10 h-10 "
              />
              <Link to="/">
                <Typography color="white" variant="h4" className=" italic font-bold uppercase">
                  Almoxarife
                </Typography>
              </Link>
            </div>
            <Hr />
            <List>
              {role == 'pcm' && (
                <MeuCadastro LIST_ITEM_STYLES={LIST_ITEM_STYLES} handleMenu={handleMenu} />
            )}
              {role == 'pcm' && (
                <MenuPcm LIST_ITEM_STYLES={LIST_ITEM_STYLES} handleMenu={handleMenu} />
              )}
              <div onClick={handleMenu}>
                <MenuItem
                  icon={<Network className="h-5 w-5" />}
                  route="/arvore-peças"
                  text="Árvore de peças"
                />
                <MenuItem icon={<TextSearch className="h-5 w-5" />} route="/" text="Produtos" />
                {role == 'pcm' && (
                  <>
                    <MenuItem
                      icon={<ClipboardList color="green" className="h-5 w-5" />}
                      route="/registrar/entradas/"
                      text="Registrar Entrada"
                    />
                    <MenuItem
                      icon={<ClipboardList color="red" className="h-5 w-5" />}
                      route="/registrar/saidas/"
                      text="Registrar Saida"
                    />
                    <MenuItem
                      icon={<History className="h-5 w-5" />}
                      route="/historico/entradas"
                      text="Historico Entrada"
                    />
                    <MenuItem
                      icon={<History className="h-5 w-5" />}
                      route="/historico/saida/"
                      text=" Historico Saida"
                    />
                    <MenuItem
                      icon={<ShoppingCart className="h-5 w-5" />}
                      route="/compras/"
                      text="Compras"
                    />
                    <MenuItem
                      icon={<TriangleAlert className="h-5 w-5" color="yellow" />}
                      route="/alert/estoque/"
                      text="Estoque Baixo"
                    />
                    <MenuItem
                      icon={<UserRoundPen className="h-5 w-5" />}
                      route="/funcionarios/"
                      text="Funcionarios"
                    />
                  </>
                )}
                {isSuper && (
                  <MenuItem
                    icon={<FileUp color="red" className="h-5 w-5" />}
                    route="/cadastroCsv/"
                    text="Importa Csv"
                  />
                )}
              </div>
              <Hr />
            </List>
          </Card>
          <List>
            <Hr />
            <ThemeMode />
            <ListItem className={`${LIST_ITEM_STYLES} `} onClick={handleLogout}>
              <ListItemPrefix>
                <ArrowLeftStartOnRectangleIcon strokeWidth={2.5} className="h-5 w-5" />
              </ListItemPrefix>
              Sair
            </ListItem>
          </List>
        </div>
      </section>
    </>
  );
};

export default NavBar;
